import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const LCP_IMAGE = 'https://cdn.magicpatterns.com/uploads/v8CQrGjZEB7TaLfVWM9c4T/Diseno-sin-titulo-_78_.webp';
function loadMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', '1318252740201550');
  w.fbq('track', 'PageView');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1318252740201550&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
function loadUtmify() {
  const w = window as any;
  if (w.__utmifyLoaded) return;
  w.__utmifyLoaded = true;
  // UTMify pixel
  w.pixelId = '6a3ae16e0cdf9b17dcbc614e';
  const pixel = document.createElement('script');
  pixel.setAttribute('async', '');
  pixel.setAttribute('defer', '');
  pixel.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
  document.head.appendChild(pixel);
  // UTMify UTM tracking
  const utms = document.createElement('script');
  utms.setAttribute('src', 'https://cdn.utmify.com.br/scripts/utms/latest.js');
  utms.setAttribute('data-utmify-prevent-xcod-sck', '');
  utms.setAttribute('data-utmify-prevent-subids', '');
  utms.setAttribute('async', '');
  utms.setAttribute('defer', '');
  document.head.appendChild(utms);
}
export function App() {
  useEffect(() => {
    // Preload LCP image for faster discovery
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = LCP_IMAGE;
    document.head.appendChild(preload);
    // Preconnect to external origins
    const origins = ['https://connect.facebook.net', 'https://www.facebook.com', 'https://cdn.utmify.com.br'];
    origins.forEach(origin => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      document.head.appendChild(link);
    });
    // Defer tracking scripts — load when browser is idle to reduce main thread work
    const loadTracking = () => {
      loadMetaPixel();
      loadUtmify();
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadTracking, {
        timeout: 3500
      });
    } else {
      setTimeout(loadTracking, 2000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}